<ng-container *ngIf="mediaItems?.length && displayCount >= 1">
    <!-- Single image / video -->
    <div *ngIf="displayCount === 1" class="ts-media-grid ts-media-grid-1" (click)="$event.stopPropagation()">
        <div class="ts-media-cell ts-media-cell-1">
            <ng-container *ngIf="isLocalVideo(gridSlice[0]); else singleNotLocalVid">
                <video controls class="ts-media-fill" [src]="getMediaUrl(gridSlice[0])" preload="metadata">
                    Your browser does not support the video tag.
                </video>
            </ng-container>
            <ng-template #singleNotLocalVid>
                <div *ngIf="gridSlice[0].mediaSource === 'local' && !isLocalVideo(gridSlice[0])" class="ts-media-inner">
                    <img [src]="getMediaUrl(gridSlice[0])" class="ts-media-fill" alt="">
                </div>
                <div *ngIf="gridSlice[0].mediaSource !== 'local'" class="ts-media-inner ts-media-gif-wrap">
                    <img [src]="gridSlice[0].isPlaying ? gridSlice[0].mediaAnimatedUrl : gridSlice[0].mediaUrl"
                         class="ts-media-fill" alt="" (click)="togglePlay(gridSlice[0].index ?? 0, $event)">
                    <div class="overlay-controls" (click)="togglePlay(gridSlice[0].index ?? 0, $event)">
                        <button *ngIf="gridSlice[0].isTenor && !gridSlice[0].isPlaying" type="button" class="btn play-btn position-absolute center" aria-label="Play GIF">
                            <svg viewBox="0 0 60 61" aria-hidden="true" class="play-icon">
                                <g>
                                    <circle cx="30" cy="30.4219" fill="#333333" opacity="0.3" r="30"></circle>
                                    <path d="M22.2275 17.1971V43.6465L43.0304 30.4218L22.2275 17.1971Z" fill="white"></path>
                                </g>
                            </svg>
                        </button>
                        <button *ngIf="gridSlice[0].isTenor && gridSlice[0].isPlaying" type="button" class="btn play-btn position-absolute center" aria-label="Pause GIF">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="106.8031 109.2966 416 416" width="50px" height="50px">
                                <g transform="matrix(1, 0, 0, 1, 58.80305480957031, 61.29664230346679)">
                                    <path d="M256,48C141.31,48,48,141.31,48,256s93.31,208,208,208,208-93.31,208-208S370.69,48,256,48ZM224,320a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Zm96,0a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Z" style="fill:#333333; opacity:0.1" />
                                </g>
                            </svg>
                        </button>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>

    <!-- Two tiles -->
    <div *ngIf="displayCount === 2" class="ts-media-grid ts-media-grid-2" (click)="$event.stopPropagation()">
        <div *ngFor="let item of gridSlice; let i = index" class="ts-media-cell ts-media-cell-tile">
            <ng-container *ngTemplateOutlet="gridCell; context: { $implicit: item, idx: i }"></ng-container>
        </div>
    </div>

    <!-- Three tiles: tall left, stacked right -->
    <div *ngIf="displayCount === 3" class="ts-media-grid ts-media-grid-3" (click)="$event.stopPropagation()">
        <div class="ts-media-span-tall">
            <div class="ts-media-cell ts-media-cell-tall">
                <ng-container *ngTemplateOutlet="gridCell; context: { $implicit: gridSlice[0], idx: 0 }"></ng-container>
            </div>
        </div>
        <div class="ts-media-stack">
            <div class="ts-media-cell ts-media-cell-stack">
                <ng-container *ngTemplateOutlet="gridCell; context: { $implicit: gridSlice[1], idx: 1 }"></ng-container>
            </div>
            <div class="ts-media-cell ts-media-cell-stack">
                <ng-container *ngTemplateOutlet="gridCell; context: { $implicit: gridSlice[2], idx: 2 }"></ng-container>
            </div>
        </div>
    </div>

    <!-- Four tiles (2×2); +N on last if more exist -->
    <div *ngIf="displayCount >= 4" class="ts-media-grid ts-media-grid-4" (click)="$event.stopPropagation()">
        <div *ngFor="let item of gridSlice; let i = index" class="ts-media-cell ts-media-cell-tile">
            <ng-container *ngTemplateOutlet="gridCell; context: { $implicit: item, idx: i }"></ng-container>
            <div *ngIf="i === 3 && extraMediaCount > 0" class="ts-media-more">+{{ extraMediaCount }}</div>
        </div>
    </div>
</ng-container>

<ng-template #gridCell let-item let-idx="idx">
    <ng-container *ngIf="isLocalVideo(item); else gridImageOrGif">
        <video controls class="ts-media-fill" [src]="getMediaUrl(item)" preload="metadata">
            Your browser does not support the video tag.
        </video>
    </ng-container>
    <ng-template #gridImageOrGif>
        <ng-container *ngIf="item.mediaSource === 'local'; else urlGrid">
            <img [src]="getMediaUrl(item)" class="ts-media-fill" alt="">
        </ng-container>
        <ng-template #urlGrid>
            <div class="ts-media-gif-wrap ts-media-inner">
                <img [src]="item.isPlaying ? item.mediaAnimatedUrl : item.mediaUrl"
                     class="ts-media-fill" alt="" (click)="togglePlay(item.index ?? idx, $event)">
                <div class="overlay-controls" (click)="togglePlay(item.index ?? idx, $event)">
                    <button *ngIf="item.isTenor && !item.isPlaying" type="button" class="btn play-btn position-absolute center" aria-label="Play GIF">
                        <svg viewBox="0 0 60 61" aria-hidden="true" class="play-icon">
                            <g>
                                <circle cx="30" cy="30.4219" fill="#333333" opacity="0.3" r="30"></circle>
                                <path d="M22.2275 17.1971V43.6465L43.0304 30.4218L22.2275 17.1971Z" fill="white"></path>
                            </g>
                        </svg>
                    </button>
                    <button *ngIf="item.isTenor && item.isPlaying" type="button" class="btn play-btn position-absolute center" aria-label="Pause GIF">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="106.8031 109.2966 416 416" width="44" height="44">
                            <g transform="matrix(1, 0, 0, 1, 58.80305480957031, 61.29664230346679)">
                                <path d="M256,48C141.31,48,48,141.31,48,256s93.31,208,208,208,208-93.31,208-208S370.69,48,256,48ZM224,320a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Zm96,0a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Z" style="fill:#333333; opacity:0.1" />
                            </g>
                        </svg>
                    </button>
                </div>
            </div>
        </ng-template>
    </ng-template>
</ng-template>
